import React, { ErrorInfo } from 'react';

type Props = React.PropsWithChildren<unknown> & {
  fallback?: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Send to monitoring service if configured (Sentry, etc.)
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 text-center">
          {this.props.fallback ?? (
            <>
              <h2 className="text-xl font-bold">Something went wrong.</h2>
              <p>Please refresh the page or contact support.</p>
            </>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
